import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import BackgroundImage from "../assets/asdf.jpg"
import HeroSectionImage from "../assets/home-comp.webp"

const HeroSection = styled.section`
  height: 77vh;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding-top: 70px;
  
  @media (max-width: 768px) {
    height: auto;
    min-height: 80vh;
    padding-top: 60px;
    padding-bottom: 40px;
  }
  
  @media (max-width: 576px) {
    min-height: 70vh;
    padding-top: 50px;
  }
`;

const StyledHeroSection = styled(HeroSection)`
  background: url(${props => props.backgroundImage});
  background-size: cover;
  background-position: center;
`;

const SocialIconsBar = styled.div`
  position: absolute;
  top: 65%;
  right: 2%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 25px;
  z-index: 100;
  padding-right: 15px;
  
  &::after {
    color: rgb(65 65 65 / 58%);
    font-weight: 900;
    content: 'Follow us on';
    position: absolute;
    top: -80px;
    right: 45px;
    transform: rotate(90deg);
    transform-origin: bottom right;
    font-size: 18px;
    letter-spacing: 1px;
    white-space: nowrap;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: -40px;
    right: 35px;
    width: 2px;
    height: 70px;
    background-color: #0066ff;
  }
  
  @media (max-width: 768px) {
    right: 0;
    gap: 20px;
    padding-right: 10px;
  }
  
  @media (max-width: 576px) {
    gap: 15px;
    padding-right: 8px;
  }
`;

const SocialIcon = styled.a`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.3s ease;
  color: #666;
  background-color: #f5f5f5;
  position: relative;
  
  &:hover {
    transform: translateY(-3px);
    color: #0066ff;
  }
  
  svg {
    font-size: 18px;
    transition: transform 0.3s ease;
  }
  
  @media (max-width: 768px) {
    width: 35px;
    height: 35px;
    
    svg {
      font-size: 16px;
    }
  }
  
  @media (max-width: 576px) {
    width: 30px;
    height: 30px;
    
    svg {
      font-size: 14px;
    }
  }
`


const HeroContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  @media (max-width: 992px) {
    align-items: start;
    flex-direction: column;
    text-align: left;
  }
`;

const HeroContent = styled.div`
  flex: 1;
  max-width: 600px;
  z-index: 1;
  
  @media (max-width: 992px) {
    margin-bottom: 40px;
    max-width: 100%;
  }
`;

const HeroTitle = styled(motion.h1)`
  font-size: 64px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 20px;
  line-height: 1.1;
  text-align: left;
  text-shadow: 3px 3px 2px #000;
  
  span {
    color: #ff6e6e;
    position: relative;
    display: inline-block;
    
    &:after {
      content: '';
      position: absolute;
      bottom: 5px;
      left: 0;
      width: 100%;
      height: 8px;
      background-color: rgba(255, 94, 20, 0.3);
      z-index: -1;
    }
  }
  
  @media (max-width: 992px) {
    font-size: 48px;
  }
  
  @media (max-width: 768px) {
    font-size: 36px;
  }
  
  @media (max-width: 576px) {
    font-size: 30px;
    
    span:after {
      height: 6px;
      bottom: 3px;
    }
  }
`;

const HeroSubtitle = styled(motion.p)`
  background: rgb(255, 255, 255, 0.5);
  border-radius: 25px;
  padding: 10px 20px;
  width: 31em;
  text-align: left;
  
  @media (max-width: 992px) {
  }
  
  @media (max-width: 768px) {
    text-align: left;
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 30px;
  }
  
  @media (max-width: 576px) {
  text-align: left;
    font-size: 15px;
    margin-bottom: 25px;
    width: 70%;
  }
`;

const ButtonGroup = styled(motion.div)`
  display: flex;
  gap: 20px;
  text-align: left;
  
  @media (max-width: 992px) {
    justify-content: left;
  }
  
  @media (max-width: 576px) {
        flex-direction: column;
        gap: 15px;
        align-items: start;
        width: 75%;
  }
`;

const PrimaryButton = styled(motion.a)`
  display: inline-flex;
  align-items: center;
  padding: 16px 32px;
  background-color: #ff6e6e;
  color: #fff;
  border-radius: 50px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 2px solid #ff6e6e;
  box-shadow: 0 10px 20px rgba(255, 94, 20, 0.3);
  
  svg {
    margin-left: 8px;
    transition: transform 0.3s ease;
  }
  
  &:hover {
    background-color: #fd4c4c;
    border-color: #fd4c4c;
    transform: translateY(-3px);
    box-shadow: 0 15px 25px rgba(255, 94, 20, 0.4);
    
    svg {
      transform: translateX(5px);
    }
  }
  
  @media (max-width: 768px) {
    padding: 14px 28px;
    font-size: 15px;
  }
  
  @media (max-width: 576px) {
    padding: 12px 24px;
    font-size: 14px;
    width: 60%;
    justify-content: center;
  }
`;

// const SecondaryButton = styled(motion.a)`
//   display: inline-block;
//   padding: 16px 32px;
//   background-color: transparent;
//   color: #fff;
//   border-radius: 50px;
//   font-weight: 600;
//   text-decoration: none;
//   transition: all 0.3s ease;
//   border: 2px solid rgba(255, 255, 255, 0.5);
  
//   &:hover {
//     background-color: rgba(255, 255, 255, 0.1);
//     border-color: #fff;
//     transform: translateY(-3px);
//   }
  
//   @media (max-width: 768px) {
//     padding: 14px 28px;
//     font-size: 15px;
//   }
  
//   @media (max-width: 576px) {
//     padding: 12px 24px;
//     font-size: 14px;
//     width: 60%;
//     justify-content: center;
//     display: inline-flex;
//   }
// `;

const ShapeElement = styled(motion.div)`
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  filter: blur(60px);
  z-index: 0;
  
  &.shape1 {
    top: -100px;
    right: -100px;
    width: 500px;
    height: 500px;
  }
  
  &.shape2 {
    bottom: -150px;
    left: -150px;
    width: 400px;
    height: 400px;
  }
  
  &.shape3 {
    top: 40%;
    left: 30%;
    width: 200px;
    height: 200px;
  }
`;

const HeroImageContainer = styled(motion.div)`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 1;
  
  @media (max-width: 992px) {
    display: none;
  }
`;

const HeroImage = styled(motion.div)`
  width: 500px;
  height: 500px;
  background: url(${props => props.heroImage});
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  
  @media (max-width: 1200px) {
    width: 400px;
    height: 400px;
  }
`;

const Hero = () => {
  return (
    <StyledHeroSection id="home" backgroundImage={BackgroundImage}>
      <SocialIconsBar>
        <SocialIcon 
          href="https://www.instagram.com/zenitechsol/" 
          aria-label="Instagram"
          as={motion.a}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
        >
          <FontAwesomeIcon icon={faInstagram} />
        </SocialIcon>
        <SocialIcon 
          href="https://www.facebook.com/zenitechsol" 
          aria-label="Facebook"
          as={motion.a}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3, delay: 0.2 }}
        >
          <FontAwesomeIcon icon={faFacebookF} />
        </SocialIcon>
        <SocialIcon 
          href="https://www.linkedin.com/company/zenitechsol/" 
          aria-label="LinkedIn"
          as={motion.a}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3, delay: 0.3 }}
        >
          <FontAwesomeIcon icon={faLinkedinIn} />
        </SocialIcon>
      </SocialIconsBar>
      <ShapeElement 
        className="shape1"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.6 }}
        transition={{ duration: 1.5 }}
      />
      <ShapeElement 
        className="shape2"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.4 }}
        transition={{ duration: 1.5, delay: 0.3 }}
      />
      <ShapeElement 
        className="shape3"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.3 }}
        transition={{ duration: 1.5, delay: 0.6 }}
      />
      
      <HeroContainer>
        <HeroContent>
          <HeroTitle
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Transforming <span>Ideas</span> Into <br />
            <span>Powerful</span> Digital Solutions
          </HeroTitle>
          
          <HeroSubtitle
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            We are a creative agency specializing in UI/UX design, development, and digital marketing solutions that drive results for businesses worldwide. Let's build something amazing together.
          </HeroSubtitle>
          
          <ButtonGroup
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <PrimaryButton 
              href="#contact"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Get Started <FontAwesomeIcon icon={faArrowRight} />
            </PrimaryButton>
            {/* <SecondaryButton 
              href="#portfolio"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              View Our Work
            </SecondaryButton> */}
          </ButtonGroup>
        </HeroContent>
        
        <HeroImageContainer
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <HeroImage heroImage={HeroSectionImage} />
        </HeroImageContainer>
      </HeroContainer>
    </StyledHeroSection>
  );
};

export default Hero;